import { render, staticRenderFns } from "./ItineraryForm.vue?vue&type=template&id=785d5c45&"
import script from "./ItineraryForm.vue?vue&type=script&lang=js&"
export * from "./ItineraryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports